<script>

	import { onMount } from 'svelte';
	import { fade, fly } from 'svelte/transition';

	import moment from 'moment-timezone';

	import Avatar from "../ui/Avatar.svelte";

	import { event, spotlight } from '../lib/stores.js';

	import { db } from "../lib/db.js";

	let mounted = false;
	let msg = $spotlight;
	let participant;

	onMount(async () => {
		msg = $spotlight;
		if (msg.sender) {
			participant = await db.attendees.get(msg.sender);
		}
		mounted = true;
	});

</script>

<style>
	#spotlight {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		display: grid;
		place-content: center;
		font-size: 2.4rem;
		cursor: none;
	}
	#spotlight:before {
		content: '';
		position: absolute;
		inset: 0;
		background: var(--bgColor);
	}
	.msg {
		position: relative;
		box-sizing: border-box;
		padding: 1em;
		width: 78vw;
	}
	.msg > div {
		position: relative;
		color: var(--textColor);
		border-radius: 8px;
		padding: 1em 1em 1em 3.8em;
		word-wrap: break-word;
		margin: 0 0.2em;
		background: var(--blend-05);
		width: 100%;
		box-sizing: border-box;
		box-shadow: 0 14px 10px -12px var(--shadow);
	}
	/*.msg.organiser > div {
		background: var(--accentBlend-10);
	}*/
	.msg :global(.avatar) {
		position: absolute;
		top: 1em;
		left: 1em;
		width: 2em;
		height: 2em;
	}
	.msg :global(p) {
		font-size: 0.9em;
		line-height: 1.4;
	}
	.person {
		margin-bottom: 0.2em;
		font-size: 0.9em;
	}
	.person strong {
		font-weight: 700;
	}
	/*.person span {
		display: inline-block;
		margin-left: 0.3em;
		opacity: 0.6;
	}
	.person em {
		display: inline-block;
		margin-left: 0.1em;
		color: var(--accentColor);
		font-style: normal;
		font-weight: 600;
	}
	.person svg {
		display: inline-block;
		margin-left: 0.2em;
		width: 0.8em;
	}
	.person svg path {
		fill: var(--accentColor);
	}
	.gif {
		max-width: 100%;
	}*/
</style>

{#if mounted}
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<div id="spotlight" in:fade={{ duration: 300 }} on:click={() => { $spotlight = null }} >

		<div
			class="msg"
			in:fly={{ duration: 400, y: 20, delay: 200 }}
		>
			<div>
				{#if !msg.anon && participant && participant.type && (participant.type == 'login') && (!participant.f || !participant.l)}
					<Avatar
						identity={participant}
						anon={true}
					>
						{#if $event.theme.favicon && $event.theme.favicon.filename}
							<img
								class="icon"
								src="https://cdn.attendzen.io/{$event.accountRef}/{$event.theme.favicon.filename}"
								alt={$event.name}
								crossorigin="anonymous"
							/>
						{/if}
					</Avatar>
				{:else}
					<Avatar
						identity={participant}
						anon={msg.anon}
					/>
				{/if}
				<p class="person">
					{#if msg.anon}
						<strong>Anonymous</strong>
					{:else}
						{#if participant}
							{#if (participant.type == 'login') && (!participant.f || !participant.l)}
								<strong>{$event.name}</strong>
							{:else}
								<strong>{participant.f} {participant.l}</strong>
							{/if}
						{/if}
					{/if}
				</p>
				<div class="message" class:emoji={(msg.message.length == 9) && (/\p{Extended_Pictographic}/u.test(msg.message))}>
					{@html msg.message}
				</div>
			</div>
		</div>

	</div>
{/if}